import React from 'react';

/**
 * StageList — vertical sequence of steps (05 §2.7). Each item may carry a
 * one-line judgement (rendered prominently) plus a body.
 */
const StageList = ({ items, start = 1 }) => (
  <div>
    {items.map((item, i) => (
      <div className="cy-stage" key={i}>
        <div className="cy-stage__num">{String(i + start).padStart(2, '0')}</div>
        <div className="cy-stage__content">
          <h3 className="cy-stage__title">{item.title || item.name}</h3>
          {item.judgement ? <p className="cy-stage__judgement">{item.judgement}</p> : null}
          {item.body || item.io || item.note ? (
            <div className="cy-stage__body">
              {item.body ? <p>{item.body}</p> : null}
              {item.io ? (
                <p>
                  <strong>You / we provide:</strong> {item.io}
                </p>
              ) : null}
              {item.input ? (
                <p>
                  <strong>Input:</strong> {item.input}
                </p>
              ) : null}
              {item.role ? (
                <p>
                  <strong>Our role:</strong> {item.role}
                </p>
              ) : null}
              {item.continue ? (
                <p>
                  <strong>Continue when:</strong> {item.continue}
                </p>
              ) : null}
              {item.stop ? (
                <p>
                  <strong>Stop when:</strong> {item.stop}
                </p>
              ) : null}
              {item.note ? (
                <p>
                  <strong>Note:</strong> {item.note}
                </p>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    ))}
  </div>
);

export default StageList;
